export default __webpack_public_path__ + "static/media/goi_logo.907c7e16.svg";